/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmFunkcniMisto extends GContentBase<SeznamAdmFunkcniMistoObj> {
        private seznamObj: SeznamAdmFunkcniMistoObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmFunkcniMistoObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmFunkcniMistoNew",
                contentCaption: (this.ixs_ref) ? "jres:33000925" : "jres:33000093",
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_fun}"
                },
                gridSettings: {
                    columnOrder: "nazev,zkratka,poznamka,ico,ixs_fun,ofic_nazev,nazev_ref,nazev_su,nazev_orj,dat_od,dat_do"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmFunkcniMistoObj extends GAdmSeznamBase {
        isPovolDeleteUserSettings: boolean;
        isPovoleneSpisUzly: boolean;
        ixs_ref: string;
        ixs_su: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmFunkcniMisto", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailAdmFunkcniMisto",
                newRecord: isNew,
                ixs_fun: isNew == true ? null : data.ixs_fun
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actSeznamAdmFunkcniMistoKonfiguracniSkupina: {
                    icon: "fa-link",
                    caption: "jres:33000015", //RC 33000015 : Konfigura�n� skupiny
                    run: () => {
                        this.openSeznamAdmFunkcniMistoKonfiguracniSkupina();
                    }
                },
                actOpenSeznamZastup: {
                    icon: "fa-link",
                    caption: "jres:32131159", //RC 32131159 : Z�stupy
                    run: () => {
                        this.openSeznamZastup();
                    }
                },
                actOpenSeznamAdmFunkcniMistoInstance: {
                    icon: "fa-link",
                    caption: "jres:33000607", //RC 33000607 : Instance funk�n�ho m�sta
                    tooltip: "jres:33000608", //RC 33000608 : Umo��uje nav�zat instance p��mo na funk�n� m�sto
                    run: () => {
                        this.openSeznamAdmFunkcniMistoInstance();
                    }
                },
                actOpenHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance: {
                    icon: "fa-link",
                    caption: "jres:33000611",
                    run: () => {
                        this.openHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance();
                    }
                },
                actOpenSeznamParametry: {
                    icon: "fa-link",
                    caption: "jres:33000853",
                    run: () => {
                        this.openSeznamParametry();
                    }
                },
                actOpenSkupinyFunkciClen: {
                    icon: "fa-link",
                    caption: "jres:33000893", //RC 33000893 : Skupiny funkc� 
                    run: () => {
                        this.openSeznamSkupinyFunkciClen();
                    }
                },
                actOpenSkupinyFunkciOpravneni: {
                    icon: "fa-link",
                    caption: "jres:33000894", //RC 33000894 : Opr�vn�n� ke skupin�m funkc�
                    run: () => {
                        this.openSkupinaFunkciOpravneni();
                    }
                },
                actOpenSeznamFunkceSchvalovaciRoleEpk: {
                    icon: "fa-link",
                    caption: "jres:33000898", //RC 33000898 : P�i�azen� schvalovac� role EPK
                    run: () => {
                        this.openSeznamFunkceSchvalovaciRoleEpk();
                    }
                },
                actOpenSeznamFunkceSchvalovaciSablonyEpk: {
                    icon: "fa-link",
                    caption: "jres:33000902", //RC 33000902 : P�i�azen� schvalovac� �ablony EPK
                    run: () => {
                        this.openSeznamFunkceSchvalovaciSablonyEpk();
                    }
                },
                //actDeleteUserSettings: {
                //    icon: "gi-settings",
                //    caption: "jres:33000062",
                //    run: () => {
                //        this.deleteUserSettings();
                //    }
                //},
                actOpenDialogDeleteUserSettings: {
                    icon: "gi-settings",
                    caption: "jres:33000864", //RC 33000864 : Smazat u�ivatelsk� nastaven� osob
                    tooltip: "jres:33000865", //RC 33000865 : Sma�e u�ivatelsk� nastaven� osob�m, kter� jsou p�i�azeny funk�n�m m�st�m.
                    enabled: this.isPovolDeleteUserSettings,
                    run: () => {
                        this.dialogDeleteUserSettings();
                    }
                },
                actOpenDialogDeleteEkoinit: {
                    icon: "gi-settings",
                    caption: "jres:33000882", //RC 33000882 : Smazat ekoinicializaci funk�n�ch m�st
                    tooltip: "jres:33000883", //RC 33000883 : Sma�e ekoinicializaci vybran�ch funk�n�ch m�st, voliteln� lze zadat i f�ze, pro kter� lze ekoinicializaci smazat.
                    enabled: this.dataListDescription.data_right?.Write ?? false,
                    run: () => {
                        this.dialogDeleteEkoinit();
                    }
                },
                actOpenSeznamAdeUcetniStrediskoFunkcniMisto: {
                    icon: "fa-link",
                    caption: "jres:33000857", //RC 33000857 : P�i�azen� st�ediska ��tov�n�
                    run: () => {
                        this.openSeznamAdeUcetniStrediskoFunkcniMisto();
                    }
                },
                actOpenSeznamAdeUctarny: {
                    icon: "fa-link",
                    caption: "jres:33000858", //RC 33000858 : P�i�azen� ��t�rny
                    run: () => {
                        this.openSeznamAdeUctarnyFunkcniMisto();
                    }
                },
                actHromadnePriraditUcetniStrediska: {
                    icon: "fa-link",
                    caption: "jres:33000859", //RC 33000859 : Hromadn� p�i�adit st�ediska ��tov�n�
                    run: () => {
                        this.openHromadnePriraditUcetniStrediska();
                    }
                },
                actHromadnePriraditUctarny: {
                    icon: "fa-link",
                    caption: "jres:33000861", //RC 33000861 : Hromadn� p�i�adit ��t�rny
                    run: () => {
                        this.openHromadnePriraditUctarny();
                    }
                },
                actPresunoutFunkcniMistaSpisovyUzel: {
                    icon: "gi-uzel |gi-user g-state-text gi-stack-pos--rb gi-bgw",
                    caption: "jres:33000935", //RC 33000935 : Zm�nit spisov� uzly funk�n�m m�st�m
                    enabled: this.dataListDescription.data_right?.Write ?? false,
                    run: () => {
                        this.openActPresunoutFunkcniMistaSpisovyUzel();
                    }
                },
                actVedlejsiSpisoveUzly: {
                    icon: "gi-uzel",
                    caption: "jres:33001027", //RC 33001030 : Vedlej�� spisov� uzly
                    visible: this.isPovoleneSpisUzly,
                    run: () => {
                        this.openVedlejsiSpisoveUzly();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*", {
                    action: this.cnt.actions.actNewDetail,
                    favorite: true,
                    visible: (this.ixs_ref == null || this.ixs_ref == undefined) && (this.ixs_su == null || this.ixs_su == undefined)
                },
                "actAddToComparison*",
                "actOpenDialogVyberovaSkupina*",
                {
                    favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                        { action: this.cnt.actions.actOpenSeznamZastup },
                        { action: this.cnt.actions.actOpenSeznamAdmFunkcniMistoInstance },
                        { action: this.cnt.actions.actSeznamAdmFunkcniMistoKonfiguracniSkupina },
                        { action: this.cnt.actions.actOpenSeznamParametry },
                        { action: this.cnt.actions.actOpenSkupinyFunkciClen },
                        { action: this.cnt.actions.actOpenSkupinyFunkciOpravneni },
                        { action: this.cnt.actions.actOpenSeznamFunkceSchvalovaciRoleEpk },
                        { action: this.cnt.actions.actOpenSeznamFunkceSchvalovaciSablonyEpk },
                        { type: "separator" },
                        { action: this.cnt.actions.actOpenSeznamAdeUcetniStrediskoFunkcniMisto },
                        { action: this.cnt.actions.actOpenSeznamAdeUctarny },
                    ]
                },
                { action: this.cnt.actions.actOpenHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance },
                { action: this.cnt.actions.actHromadnePriraditUcetniStrediska },
                { action: this.cnt.actions.actHromadnePriraditUctarny },
                { action: this.cnt.actions.actOpenDialogDeleteUserSettings },
                { action: this.cnt.actions.actOpenDialogDeleteEkoinit },
                { action: this.cnt.actions.actPresunoutFunkcniMistaSpisovyUzel },
                { action: this.cnt.actions.actVedlejsiSpisoveUzly }
            ], this.createShareMenuBarActions()))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDetailOnNewTab*",
                "-",
                "actOpenSeznamZastup*",
                "actOpenSeznamAdmFunkcniMistoInstance*",
                "actSeznamAdmFunkcniMistoKonfiguracniSkupina*",
                "actOpenSeznamParametry*",
                "actOpenSkupinyFunkciClen*",
                "actOpenSkupinyFunkciOpravneni*",
                "actOpenSeznamFunkceSchvalovaciRoleEpk*",
                "actOpenSeznamFunkceSchvalovaciSablonyEpk*",
                "actOpenSeznamAdeUcetniStrediskoFunkcniMisto*",
                "actOpenSeznamAdeUctarny*",
                "-",
                "actHromadnePriraditUcetniStrediska*",
                "actHromadnePriraditUctarny*",
                "actOpenHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance*",
                "actOpenDialogDeleteUserSettings*",
                "actOpenDialogDeleteEkoinit*",
                "actPresunoutFunkcniMistaSpisovyUzel"
            ])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:32131110").addField("gselectbox", Gordic.Prefabs.Select.ginsref(), {
                name: "ixs_ref",
                model: "model.ixs_ref=value.ixs_ref",
                dropdown: true,
                disabled: this.ixs_ref ? true : false
            }).addRow("jres:29802637").addField("gselectbox", Gordic.Prefabs.Select.ginspod(), {
                name: "ixs_su",
                model: "model.ixs_su=value.ixs_su",
                dropdown: true,
                disabled: this.ixs_su ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_ref)
                hardFilter["ixs_ref"] = this.ixs_ref;
            if (this.ixs_su)
                hardFilter["ixs_su"] = this.ixs_su;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_ref)
                data["ixs_ref"] = this.ixs_ref;
            if (this.ixs_su)
                data["ixs_su"] = this.ixs_su;
        }

        applydata(filterData: any) {
            this.cnt.beginOperation();
            this.cnt.isl.AdmFunkcniMisto.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            }).always(() => { this.cnt.endOperation() });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actSeznamAdmFunkcniMistoKonfiguracniSkupina?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamAdmFunkcniMistoInstance?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamZastup?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamParametry?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSkupinyFunkciClen?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSkupinyFunkciOpravneni?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamFunkceSchvalovaciRoleEpk?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamFunkceSchvalovaciSablonyEpk?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance?.update({ enabled: objArr.count > 0 })
            this.cnt.actions.actOpenDialogDeleteUserSettings?.update({ enabled: objArr.count > 0 && this.isPovolDeleteUserSettings })
            this.cnt.actions.actOpenDialogDeleteEkoinit?.update({ enabled: objArr.count > 0 && (this.dataListDescription.data_right?.Write ?? false) })
            //this.cnt.actions.actDeleteUserSettings?.update({ enabled: objArr.count > 0 })
            this.cnt.actions.actHromadnePriraditUctarny?.update({ enabled: objArr.count > 0})
            this.cnt.actions.actHromadnePriraditUcetniStrediska?.update({ enabled: objArr.count > 0})
            this.cnt.actions.actOpenSeznamAdeUctarny?.update({ enabled: objArr.count == 1})
            this.cnt.actions.actOpenSeznamAdeUcetniStrediskoFunkcniMisto?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actPresunoutFunkcniMistaSpisovyUzel?.update({ enabled: objArr.count > 0 && (this.dataListDescription.data_right?.Write ?? false) })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_fun}`,
                nazev: data["nazev"]
            }
        }

        private openSeznamAdmFunkcniMistoKonfiguracniSkupina() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmFunkcniMistoKonfiguracniSkupina", { ixs_fun: activeRow.ixs_fun })
        }

        private openSeznamZastup() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamZastup", { ixs_fun: activeRow.ixs_fun })
        }

        private openSeznamAdmFunkcniMistoInstance() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmKonfiguracniSkupinaProgramovaInstance", { ixs_fun: activeRow.ixs_fun, typ_usr: 10 }])
        }

        private openHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance() {
            const selection = this.grid.ggrid("getSelection");
            const data: Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaProgramovaInstanceReadDto[] = [];
            if (selection.length > 0) {
                selection.forEach((item) => {
                    data.push({
                        ixs_usr: item["ixs_fun"]
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance"], { ID: "HromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance", data: data, typ_usr: 10 }, "", 1000, 600)
        }

        private openSeznamParametry() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmParametrGlobal"], { ixs_fun: activeRow.ixs_fun, uroven_cfg: 60 })
        }

        private deleteUserSettings() {
            const selection = this.grid.ggrid("getSelection");
            if (selection.length > 0) {
                const req: Gordic.AdmIsl.Interface.GAdmFunkcniMistoDto[] = selection.map((value) => ({
                    ixs_fun: value.ixs_fun,
                    nazev: value.nazev
                }));
                this.cnt.isl.AdmFunkcniMisto.deleteAppUserSettings({ rq: req }).get().then((data) => {
                    data.forEach((result) => {
                        const index = req.findIndex((item) => item.ixs_fun == result.data.ixs_fun)
                        if (index > -1)
                            req.splice(index, 1)
                    })
                    let successData: string = "<b>jres:33000854</b><br />"; //RC 33000854 : �sp�n� smazan� u�ivatelsk� nastaven�:
                    for (var i = 0; i < data.length; i++) {
                        const ixs_fun_txt = ` (${data[i].data.ixs_fun})`
                        successData += `${data[i].data.nazev}${data[i].data.ixs_fun ? ixs_fun_txt : ''}`;
                        successData += i == (data.length - 1) ? "." : ", ";
                    }
                    let errorData: string = "";
                    if (req.length > 0) {
                        errorData = "<br /><b>jres:33000855</b><br />" //RC 33000855 : Ne�sp�n� smaz�n� u�ivatelsk�ho nastaven�: 
                        for (var i = 0; i < req.length; i++) {
                            const ixs_fun_txt = req[i].nazev == null ? "-" : req[i].nazev;
                            const ixs_fun = ` (${req[i].ixs_fun})`;
                            errorData += `${ixs_fun_txt} ${ixs_fun}`
                            errorData += i == (req.length - 1) ? "." : ", ";
                        }
                    }
                    this.cnt.notification("showToast", {
                        title: this.options.contentCaption,
                        content: `${successData} ${errorData}`,
                        state: req.length > 0 ? "info" : "success",
                        icon: "gi-settings"
                    })
                }).always(() => {
                    this.cnt.endOperation();
                })
            }
        }

        private dialogDeleteUserSettings() {
            const selection: Gordic.AdmIsl.Interface.GAdmFunkcniMistoListDto[] = this.grid.ggrid("getSelection");
            if (selection.length > 0) {
                this.cnt.dialogs.showModalWindow([Gordic.Adm.WebControls.DialogDeleteUserSettings, {
                    funkcniMista: selection.map(item => item.ixs_fun),
                    rezimDialog: Gordic.Adm.WebControls.RezimDialog.fukncniMisto
                }], {}, {
                    width: 600,
                    height: 400
                });
            }
        }

        private dialogDeleteEkoinit() {
            const selection: Gordic.AdmIsl.Interface.GAdmFunkcniMistoListDto[] = this.grid.ggrid("getSelection");
            if (selection.length > 0) {
                this.cnt.dialogs.showModalWindow([Gordic.Adm.WebControls.DialogAdmFunkcniMistoDeleteEkonini, {
                    funkcniMista: selection.map(item => item.ixs_fun)
                }], {}, {
                    width: 600,
                    height: 400
                });
            }
        }

        private openSeznamAdeUcetniStrediskoFunkcniMisto() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Ade.WebControls.SeznamAdeUcetniStrediskoFunkcniMisto"], { ixs_fun: activeRow.ixs_fun, ico: activeRow.ico })
        }

        private openSeznamAdeUctarnyFunkcniMisto() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Ade.WebControls.SeznamAdeUctarnaFunkcniMisto"], { ixs_fun: activeRow.ixs_fun, ico: activeRow.ico })
        }

        private openHromadnePriraditUcetniStrediska() {
            const selection: Gordic.AdmIsl.Interface.GAdmFunkcniMistoListDto[] = this.grid.ggrid("getSelection");
            if (selection.length > 0) {
                const data: Gordic.AdmIsl.Interface.GAdeUcetniStrediskoFunkcniMistoReadDto[] = selection.map((item) => ({ ico: item.ico, ixs_fun: item.ixs_fun }));
                const icos = data.map(x => x.ico);
                if (icos.every((val, i, arr) => val == icos[0]) == true) 
                    this.cnt.dialogs.showModalWindow(["Gordic.Ade.WebControls.HromadnaOperaceAdeUcetniStrediskoFunkcniMisto", { openFromFunkcniMisto: true }], { ID: "HromadnaOperaceAdeUcetniStrediskoFunkcniMisto", data: data }, "", 1000, 600)
                else
                    this.cnt.dialogs.error("jres:32000124", "jres:33000860") //RC 33000860 : Jsou vybr�na funk�n� m�sta s rozd�ln�m I�O, proto je nelze hromadn� p�i�azovat.
            }
        }

        private openHromadnePriraditUctarny() {
            const selection: Gordic.AdmIsl.Interface.GAdmFunkcniMistoListDto[] = this.grid.ggrid("getSelection");
            if (selection.length > 0) {
                const data: Gordic.AdmIsl.Interface.GAdeUctarnaFunkcniMistoReadDto[] = selection.map((item) => ({ ico: item.ico, ixs_fun: item.ixs_fun }));
                const icos = data.map(x => x.ico);
                if (icos.every((val, i, arr) => val == icos[0]) == true) 
                    this.cnt.dialogs.showModalWindow(["Gordic.Ade.WebControls.HromadnaOperaceAdeUctarnaFunkcniMisto", { openFromFunkcniMisto: true }], { ID: "HromadnaOperaceAdeUctarnaFunkcniMisto", data: data }, "", 1000, 600)
                else 
                    this.cnt.dialogs.error("jres:32000124", "jres:33000860") //RC 33000860 : Jsou vybr�na funk�n� m�sta s rozd�ln�m I�O, proto je nelze hromadn� p�i�azovat.
            }
        }
        private openSeznamSkupinyFunkciClen() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamSkupinaFunkciClen", { ixs_fun: activeRow.ixs_fun })
        }

        private openSkupinaFunkciOpravneni() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamSkupinaFunkciOpravneni", { ixs_fun: activeRow.ixs_fun })
        }

        private openSeznamFunkceSchvalovaciRoleEpk() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamFunkceSchvalovaciRoleEpk", { ixs_fun: activeRow.ixs_fun })
        }

        private openSeznamFunkceSchvalovaciSablonyEpk() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamFunkceSchvalovaciSablonyEpk", { ixs_fun: activeRow.ixs_fun })
        }

        private openActPresunoutFunkcniMistaSpisovyUzel() {
            const selection: Gordic.AdmIsl.Interface.GAdmFunkcniMistoListDto[] = this.grid.ggrid("getSelection");
            if (selection.length > 0) {
                var firstIco = selection[0].ico;
                var sameIco = selection.every(obj => obj.ico?.trim() == firstIco?.trim());
                if (sameIco == true) {
                    this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.DialogAdmFunkcniMistoSpisovyUzel"], {
                        funkcni_mista: selection
                    }, {
                        width: 1000,
                        height: 600
                    })
                } else {
                    this.cnt.dialogs.error("jres:33000938", "jres:33000939"); //RC 33000939 : Jsou vybr�na funk�n� m�sta s rozd�ln�m i�o, nelze je tedy p�esouvat na jeden spisov� uzel.
                }
            }
        }

        private openVedlejsiSpisoveUzly() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmPovolenySpisovyUzelFunkce"])
        }
    }
}